import { schema } from 'normalizr';

export const rule = new schema.Entity('rules');
